import script from "./RelatorioControl.vue?vue&type=script&setup=true&lang=js"
export * from "./RelatorioControl.vue?vue&type=script&setup=true&lang=js"

import "./RelatorioControl.vue?vue&type=style&index=0&id=7e85a08c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e85a08c"]])

export default __exports__